import React, { useState } from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import AxiosUrl from "../../AxiosUrl";
import { toast } from "react-toastify";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./DeleteWithdrawModal.css";

function DeleteWithdrawModal({ open, onClose, withdrawalData, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleDelete = () => {
    if (!withdrawalData || !withdrawalData._id) {
      toast.error("Invalid withdrawal data");
      return;
    }

    setLoading(true);
    const uid = localStorage.getItem("id");

    AxiosUrl.delete(`/delete-withdraw/${uid}`, {
      data: { withdrawId: withdrawalData._id }
    })
      .then((res) => {
        toast.success(res.data.Message || "Withdrawal deleted successfully");
        onSuccess && onSuccess();
        onClose();
      })
      .catch((error) => {
        console.error("Error deleting withdrawal:", error);
        toast.error(
          error.response?.data?.Error || "Failed to delete withdrawal"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      open={open}
      onClose={loading ? null : onClose}
      aria-labelledby="delete-withdraw-modal-title"
      aria-describedby="delete-withdraw-modal-description"
    >
      <Box className={`delete-withdraw-modal ${isMobile ? 'delete-withdraw-modal-mobile' : ''}`}>
        <div className="delete-withdraw-modal-header">
          <Typography variant="h6" component="h2" className="delete-withdraw-modal-title">
            Confirm Deletion
          </Typography>
          {!loading && (
            <CloseIcon 
              className="delete-withdraw-modal-close-icon" 
              onClick={onClose}
            />
          )}
        </div>

        <div className="delete-withdraw-modal-content">
          <Typography className="delete-withdraw-modal-message">
            Are you sure you want to delete this withdrawal request?
          </Typography>
          
          {withdrawalData && (
            <div className="delete-withdraw-modal-details">
              <div className="delete-withdraw-modal-detail-item">
                <span className="delete-withdraw-modal-detail-label">User:</span>
                <span className="delete-withdraw-modal-detail-value">
                  {withdrawalData.user?.username || "Unknown User"}
                </span>
              </div>
              <div className="delete-withdraw-modal-detail-item">
                <span className="delete-withdraw-modal-detail-label">Amount:</span>
                <span className="delete-withdraw-modal-detail-value">
                  {withdrawalData.Amount || "N/A"}
                </span>
              </div>
              <div className="delete-withdraw-modal-detail-item">
                <span className="delete-withdraw-modal-detail-label">Number:</span>
                <span className="delete-withdraw-modal-detail-value">
                  {withdrawalData.Number || "N/A"}
                </span>
              </div>
              <div className="delete-withdraw-modal-detail-item">
                <span className="delete-withdraw-modal-detail-label">Type:</span>
                <span className="delete-withdraw-modal-detail-value">
                  {withdrawalData.Type || "N/A"}
                </span>
              </div>
              <div className="delete-withdraw-modal-detail-item">
                <span className="delete-withdraw-modal-detail-label">Status:</span>
                <span className="delete-withdraw-modal-detail-value">
                  {withdrawalData.Status === 0
                    ? "Pending"
                    : withdrawalData.Status === 1
                    ? "Approved"
                    : "Rejected"}
                </span>
              </div>
            </div>
          )}
          
          <Typography className="delete-withdraw-modal-warning">
            This action cannot be undone.
          </Typography>
        </div>

        <div className="delete-withdraw-modal-actions">
          <Button
            onClick={onClose}
            disabled={loading}
            className="delete-withdraw-modal-cancel-button"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            disabled={loading}
            className="delete-withdraw-modal-delete-button"
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <>
                <DeleteIcon className="delete-withdraw-modal-delete-icon" />
                Delete
              </>
            )}
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

export default DeleteWithdrawModal; 